let SOLAR_VENDOR_ID = 'solar-vendor-id';
let SOLAR_TENANT_CODE = 'solar-tenant-code';

export const setVendorStorage = (vendorId: string | null | undefined, tenantCode: string | null | undefined) => {
  if(vendorId){
    window.sessionStorage.setItem(SOLAR_VENDOR_ID, vendorId);
    document.cookie = `vendorId=${vendorId}; path=/; max-age=31536000`;
  }
  if(tenantCode){
    window.sessionStorage.setItem(SOLAR_TENANT_CODE, tenantCode);
    document.cookie = `tenantCode=${tenantCode}; path=/; max-age=31536000`;
  } else {
    window.sessionStorage.removeItem(SOLAR_TENANT_CODE);
  }
}

export const getVendorStorage = () => {
  return {
    vendorId: window.sessionStorage.getItem(SOLAR_VENDOR_ID) as string,
    tenantCode: window.sessionStorage.getItem(SOLAR_TENANT_CODE) as string,
  }
}

export const removeVendorStorage = () => {
  window.sessionStorage.removeItem(SOLAR_VENDOR_ID);
  window.sessionStorage.removeItem(SOLAR_TENANT_CODE);
  // 同时删除 cookie
  document.cookie = `vendorId=; path=/; max-age=0`;
  document.cookie = `tenantCode=; path=/; max-age=0`;
}

export const getSolarToken = () => {
  const url = window.location.href;
  const regex = /[?&]solar-token=([^&#/]*)/;
  const match = url.match(regex);
  return match ? match[1] : null;
}